import React, { FC, useContext } from "react";
import DogCatImage from "./../../../Static/Images/Dog_cat.png";
import ThanksMessage from "./../../../Static/Images/thanks_message.png";
import ThanksMessageCreditCard from "./../../../Static/Images/thanks_message_credit_card.png";
import Outlook from "./../../../Static/Images/outlook.png";
import Gmail from "./../../../Static/Images/gmail.png";
import Yahoo from "./../../../Static/Images/yahoo.png";
import {
  CompraSuccessContainer,
  CompraSucessTitle,
  DogCatContainer,
  ThanksMessageContainer,
  EmailContainer,
  EmailImage,
  LinkFatura,
  AtivacaoAssinatura,
} from "./../Checkout.styles";
import { Header, Rodape } from "../../../Components";
import { useHistory } from "react-router-dom";
import { PlanoContext } from "../../../Context/Plano/Plano.Provider";
import { CompraContext } from "../../../Context/Compra/Compra.Provider";
import { withCompraContext } from "../../../Context/Compra";
import { withPlanoContext } from "../../../Context/Plano";

const SuccessCompra: FC = () => {
  const planoContext = useContext(PlanoContext);
  const compraContext = useContext(CompraContext);
  const history = useHistory();

  return (
    <>
      <Header
        showPlan={false}
        history={history}
        plano={(planoContext.result as any).data}
      />
      <CompraSuccessContainer>
        <CompraSucessTitle>Muito Obrigado!</CompraSucessTitle>
        <DogCatContainer src={DogCatImage} />
        {compraContext.result.data.hasFatura &&
          compraContext.result.data.recent_invoices &&
          compraContext.result.data.recent_invoices[0] && (
            <LinkFatura
              href={compraContext.result.data.recent_invoices[0].secure_url}
              target="_BLANK"
            >
              Clique aqui para visualizar sua fatura
            </LinkFatura>
          )}
        {!compraContext.result.data.hasFatura && (
          <>
            <ThanksMessageContainer
              src={
                compraContext.result.data.paiedWithCreditCard
                  ? ThanksMessageCreditCard
                  : ThanksMessage
              }
            />
            <EmailContainer>
              <EmailImage href="http://outlook.com/" target="_BLANK">
                <img alt="Outlook" src={Outlook} />
              </EmailImage>
              <EmailImage href="https://gmail.com/" target="_BLANK">
                <img alt="Gmail" src={Gmail} />
              </EmailImage>
              <EmailImage href="https://yahoo.com/" target="_BLANK">
                <img alt="Yahoo" src={Yahoo} />
              </EmailImage>
            </EmailContainer>
            <AtivacaoAssinatura>
              A assinatura será ativada assim que o seu pagamento for validado.
            </AtivacaoAssinatura>
          </>
        )}
        <Rodape showNeedHelp={false} />
      </CompraSuccessContainer>
    </>
  );
};

export default withCompraContext(withPlanoContext(SuccessCompra));

